import React, { useState } from 'react';
import { usePathname, useRouter } from 'src/routes/hooks';
import { Dialog, DialogContent, DialogActions, Stack, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from 'notistack';



function ApprovalDialog() {

  const { enqueueSnackbar } = useSnackbar();
  const {  logout } = useAuthContext();
  const router = useRouter();

  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogueOpen, setDialogueOpen] = useState(true);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDialogueClose = () => {
    setAnchorEl(null);
    handleLogout(); 
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logout();
      router.replace('/');
    } catch (error) {
      console.log("Error:"+error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  return (
    <Stack>
      <Dialog open={dialogueOpen}>
        <DialogContent>
          <Stack
            width="560px"
            height="400px"
            bgcolor="white"
            borderRadius="16px"
            justifyContent="center"
            alignItems="center"
          >
            <AccessTimeRoundedIcon sx={{ fontSize: 80 }} />
            <Typography
              variant="h3"
              sx={{
                fontSize: '24px',
                fontFamily:'manrope, sans-serif',
                fontWeight: 600,
                textAlign: 'left',
                marginBottom: '5px',
                marginTop: '24px',
              }}
            >
              Your Account Is under Approval
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: '16px',
                fontFamily:'manrope ,sans-serif',
                fontWeight: 400,
                textAlign: 'left',
                marginBottom: '16px',
                color:'#A0A0A0'
              }}
            >
              Your registration is pending approval. We will notify you upon completion.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ position: 'absolute', top: '0px', right: '0px' }}>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              sx: {
                width: '112px',
                maxHeight: '40px',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              key={'Logout'}
              onClick={handleDialogueClose}
              sx={{
                fontSize: '14px',
                fontFamily: 'manrope, sans-serif',
                fontWeight: 400,
                padding: '8px 16px',
                margin: '0',
              }}
            >
              Log out
            </MenuItem>
          </Menu>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}

export default ApprovalDialog;
